import EgPlayer from "@atm/eg-player";

import { PLAYER_SETTINGS, STREAM_SETTINGS } from "./constants";

export class PlayerService {
  player: EgPlayer | null;
  private initPromise: Promise<void> | null;
  private shouldStop: boolean;

  constructor() {
    this.player = null;
    this.initPromise = null;
    this.shouldStop = false;
  }

  play() {
    if (this.player || !EgPlayer) {
      return;
    }

    if (this.initPromise) {
      this.shouldStop = false;
      return;
    }

    const element = document.getElementById("player");

    if (!(element instanceof HTMLVideoElement)) {
      return;
    }

    this.shouldStop = false;

    this.initPromise = this.init(element);
  }

  stop() {
    this.shouldStop = true;

    if (this.player) {
      this.player.stop();
      this.player = null;
    }
  }

  private async init(element: HTMLVideoElement) {
    try {
      const player = await EgPlayer({ ...PLAYER_SETTINGS, element });

      if (this.shouldStop) {
        player.stop();
        return;
      }

      this.player = player;
      await this.player.start({ ...STREAM_SETTINGS });
    } catch {
      this.player = null;
    } finally {
      this.initPromise = null;
    }
  }
}
